import { JitsiMeeting } from '@jitsi/react-sdk';
import CustomSpinner from '../infrastructure/customSpinner';
import { WarningOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { IJitsiMeetExternalApi } from '@jitsi/react-sdk/lib/types';
import { Modal } from 'antd';
import { useReactMediaRecorder } from '../mediaRecorder';

export interface IMeetPropsps {
    roomName: string;
    userName: string;
    onClosed: (mediaBlobUrl?: string | null, fileName?: string) => Promise<void>;
}

export const Meet = (props: IMeetPropsps) => {
    const [recordingStatus, setRecordingStatus] = useState({ on: false, mode: "file" as "file" | "stream", hasRecording: false });
    const [api, setApi] = useState<IJitsiMeetExternalApi>({} as any);
    const [hangup, setHangup] = useState<boolean>(false);

    const {
        status,
        startRecording: startRecord,
        stopRecording: stopRecord,
        mediaBlobUrl,
    } = useReactMediaRecorder({ screen: true, audio: true, video: false });

    const onClose = async () => {
        const downloadRecordingType = "mp4";
        const currentTimeSatmp = new Date().getTime();
        const pathName = `${props.roomName}_${currentTimeSatmp}.${downloadRecordingType}`;
        if (mediaBlobUrl) {
            try {
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    // for IE
                    (window.navigator as any).msSaveOrOpenBlob(mediaBlobUrl, pathName);
                } else {
                    // for Chrome
                    const link = document.createElement("a");
                    link.href = mediaBlobUrl;
                    link.download = pathName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            } catch (err) {
                console.error(err);
            }
        }
        await props.onClosed(mediaBlobUrl, pathName);
    };

    useEffect(() => {
        if (!(api as any).removeAllListeners) {
            return;
        }

        if ((hangup && status === "recording") || (status === 'stopped' && recordingStatus.on)) {
            //api.stopRecording(recordingStatus.mode);
            api.emit('recordingStatusChanged', { on: false });
        }

        if (hangup && (status === "idle" || (status === "stopped" && mediaBlobUrl))) {
            onClose();
            return;
        }

        if (hangup && !recordingStatus.on) {
            api.executeCommand('hangup');
        }

        api.removeAllListeners();
        api.addListener('toolbarButtonClicked', ({ key, preventExecution }) => {
            if (key === "hangup") {
                if (preventExecution) {
                    Modal.confirm({
                        direction: "rtl",
                        content: "آیا مایلید تماس خاتمه یابد؟",
                        onOk: () => {
                            if (recordingStatus.on) {
                                //api.stopRecording(recordingStatus.mode);
                                api.emit('recordingStatusChanged', { on: false });
                            }
                            setHangup(true);
                        },
                        okText: "بلی",
                        cancelText: "خیر",
                        centered: true,
                        icon: <WarningOutlined />
                    });
                }
            }
            else if (key === "recording") {
                if (recordingStatus.on) {
                    //api.executeCommand('stopRecording', recordingStatus.mode);
                    api.emit('recordingStatusChanged', { on: false });
                }
                else {
                    //api.executeCommand('startRecording', { mode: 'file' });
                    api.emit('recordingStatusChanged', { on: true });
                }
            }
        });

        api.addListener('recordingStatusChanged', ({ on, mode }) => {
            setRecordingStatus({ on, mode, hasRecording: true });
            if (on) {
                startRecord();
            }
            else {
                stopRecord();
            }
        });

    }, [api, recordingStatus, hangup, mediaBlobUrl, status]);

    return (
        <div style={{ height: "calc(100vh - 160px)" }}>
            <JitsiMeeting
                configOverwrite={{
                    prejoinConfig: { enabled: false },
                    buttonsWithNotifyClick: ['hangup', 'recording'],
                    toolbarButtons: ['hangup', 'camera', 'microphone', 'fullscreen', 'videoquality', 'recording']
                }}

                roomName={props.roomName}
                userInfo={{ displayName: props.userName, email: "" }}
                getIFrameRef={node => {
                    node.style.height = '100%';
                    Modal.warning({
                        direction: "rtl",
                        title: 'هشدار',
                        content: 'لطفا ضبط تماس فراموش نشه...',
                        okText: "باشه",
                        centered: true
                    });
                }}
                onApiReady={jitsiApi => {
                    setApi(jitsiApi);

                }}
                spinner={CustomSpinner}
            />
        </div>
    );
}
